// extracted by mini-css-extract-plugin
module.exports = {"light":"Wrapper_light__2aOti","card":"Wrapper_card__2STmr","loaderBlock":"Wrapper_loaderBlock__1HcFf","noData":"Wrapper_noData__2AgYx","sourceList":"Wrapper_sourceList__1X8M3"};